import React from 'react';
import PropTypes from 'prop-types';
// TODO: ABTest SBOOK-591 CLEANUP: SBOOK-549 New Layout
// import { Experiment, Variant } from '@marvelapp/react-ab-test/index';
// AB-test END
import Translate from './Translate';
import PriceFormatter from './formatterComponents/PriceFormatter';
import Tooltip from './Tooltip';

const PaymentRatesListElement = ({rate}) => (
  <ul>
    {/* TODO: ABTest SBOOK-591 CLEANUP: SBOOK-549 New Layout */}
    {/* IMPORTANT: Keep Variant A */}
    {/* <Experiment name='ABTest_SBOOK549_NewLayout'>
      <Variant name='A'> */}
    <li className="first">
      <Translate content="Rates" /> 
      {' '}
      {rate.paymentId}
      {' '}
      – 
      {' '}
      {rate.localizedPaymentDate}
    </li>
    <li className="second payment-rates-list__item--card">
      <i className="fa fa-credit-card" />
    </li>
    <li className="third payment-rates-list__item--tooltip">
      {rate.description ? (
        <Tooltip>
          {rate.description}
        </Tooltip>
      ) : null}
    </li>
    <li className="fourth">
      <PriceFormatter price={rate.price} />
    </li>
      {/* </Variant>
      <Variant name='B'>
        <li className="abtestsbook549__rates">
          <div>
            <div>
              <Translate content="Rates" /> 
              {' '}
              {rate.paymentId}
            </div>
            <div className="abtestsbook549__rates-date">
              {rate.localizedPaymentDate}
            </div>
          </div>
          <div className="abtestsbook549__rates-price">
            <PriceFormatter price={rate.price} />
          </div>
        </li>
        {rate.description ? (
          <li className="third payment-rates-list__item--tooltip">
            {rate.description}
          </li>
        ) : null}
      </Variant>
    </Experiment> */}
    {/* AB-Test END */}
  </ul>
);

PaymentRatesListElement.PropTypes = {
  rate:PropTypes.shape({
    paymentId:PropTypes.number.isRequired,
    localizedPaymentDate:PropTypes.string.isRequired,
    price:PropTypes.object.isRequired,
  }).isRequired,
};

export default PaymentRatesListElement;
